import { Button } from "@mantine/core";

import { useDispatch, useSelector } from "../../../../redux/hooks";
import {
  clearUsersToSendWelcomeEmail,
  setIsSendingWelcomeEmail,
  setSelectAll,
} from "../../../../redux/slices/managementSlice";
import { usePostApi } from "../../../../hooks";
import { Notification } from "../../../../utils/Notification";
import { useState } from "react";
import ConfirmationButton from "../../../shared/ConfirmationButton/ConfirmationButton";

const WelcomeEmailsControls = () => {
  const dispatch = useDispatch();

  const { isSendingWelcomeEmails, usersToSendWelcomeEmail } = useSelector(
    state => state.managementSlice,
  );
  const [isLoading, setIsLoading] = useState(false);
  const toggleSendingWelcomeEmails = () => {
    dispatch(clearUsersToSendWelcomeEmail());
    dispatch(setIsSendingWelcomeEmail(!isSendingWelcomeEmails));
  };
  const handleCancel = () => {
    dispatch(setSelectAll(false));
    toggleSendingWelcomeEmails();
  };
  const { post } = usePostApi();

  const handleSendEmails = async () => {
    try {
      setIsLoading(true);
      const emailPromises = usersToSendWelcomeEmail.map(userid =>
        post({
          request: "send-welcome",
          body: { params: { userid } },
        }),
      );
      await Promise.all(emailPromises);

      Notification(
        "Success",
        "The welcome mail has been sent to this user successfully",
        "green",
      );
    } catch (e) {
      Notification("Error", "Failed to send welcome emails", "red");
    } finally {
      setIsLoading(false);
    }

    toggleSendingWelcomeEmails();
  };

  return (
    <div style={{ display: "flex", gap: 5 }}>
      {isSendingWelcomeEmails && (
        <Button variant="outline" color="red" onClick={handleCancel}>
          Cancel
        </Button>
      )}
      {isSendingWelcomeEmails ? (
        <ConfirmationButton
          onConfirm={handleSendEmails}
          buttonProps={{ disabled: usersToSendWelcomeEmail.length === 0 }}
          loading={isLoading}
          modalText="Confirm sending emails to multiple users">
          Confirm sending
        </ConfirmationButton>
      ) : (
        <Button variant="outline" onClick={toggleSendingWelcomeEmails}>
          Send Welcome Emails
        </Button>
      )}
    </div>
  );
};
export default WelcomeEmailsControls;
